(function () {
  var KEY = 'trivelle:attr';
  var SESSION_MS = 30 * 60 * 1000;
  var state = null;

  function readStore() {
    try { return JSON.parse(localStorage.getItem(KEY) || 'null') || {}; } catch (e) { return {}; }
  }
  function writeStore(s) {
    try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {}
  }

  function getCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }
  function setCookie(name, value, maxAge) {
    var c = name + '=' + encodeURIComponent(value) + '; Path=/; Max-Age=' + maxAge + '; SameSite=Lax';
    if (location.protocol === 'https:') c += '; Secure';
    document.cookie = c;
  }
  function uuid() {
    try { return crypto.randomUUID(); } catch (e) {
      return 'tv-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
    }
  }

  var INTERNAL_FLAG = 'tv_internal';
  var INTERNAL_MAX_AGE = 30 * 24 * 3600;

  function internalVisit() {
    var flag = null;
    try { flag = new URLSearchParams(location.search).get(INTERNAL_FLAG); } catch (e) {}
    if (flag === '0') { setCookie(INTERNAL_FLAG, '0', 0); return false; }
    if (flag === '1') setCookie(INTERNAL_FLAG, '1', INTERNAL_MAX_AGE);
    return flag === '1' || getCookie(INTERNAL_FLAG) === '1';
  }

  function tagClarityInternal(triesLeft) {
    if (typeof window.clarity === 'function') {
      try { window.clarity('set', 'internal', '1'); } catch (e) {}
      return;
    }
    if (triesLeft > 0) setTimeout(function () { tagClarityInternal(triesLeft - 1); }, 2000);
  }

  if (internalVisit()) {
    tagClarityInternal(5);
    return;
  }

  var CARRY_KEY = '.tv=';
  function b64u(s) {
    return btoa(unescape(encodeURIComponent(s))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
  function unb64u(s) {
    s = s.replace(/-/g, '+').replace(/_/g, '/');
    while (s.length % 4) s += '=';
    return decodeURIComponent(escape(atob(s)));
  }
  var carried = null;
  function readCarried() {
    if (carried !== null) return carried;
    carried = {};
    try {
      var h = location.hash || '';
      var i = h.indexOf(CARRY_KEY);
      if (i === -1) return carried;
      var raw = h.slice(i + CARRY_KEY.length).split('&')[0];
      var obj = JSON.parse(unb64u(raw));
      if (obj && typeof obj === 'object') carried = obj;
      var clean = location.pathname + location.search + h.slice(0, i);
      history.replaceState(history.state, '', clean);
    } catch (e) { carried = {}; }
    return carried;
  }
  function carry() {
    try {
      var store = readStore();
      var payload = { v: store.vid || (state && state.vid) || null, s: store.sid || null, a: store.attr || null };
      return payload.v ? b64u(JSON.stringify(payload)) : '';
    } catch (e) { return ''; }
  }

  var mintAllowed = false;

  function ensureIds() {
    var store = readStore();
    var now = Date.now();
    var c = readCarried();
    var cv = typeof c.v === 'string' ? c.v.slice(0, 100) : null;
    var cs = typeof c.s === 'string' ? c.s.slice(0, 100) : null;
    var vid = getCookie('_tv_vid') || store.vid || cv || uuid();

    var sid = getCookie('_tv_sid') || store.sid || cs || null;
    var expired = !store.la || now - store.la > SESSION_MS;
    if (!sid || (expired && !getCookie('_tv_sid') && sid !== cs)) sid = uuid();

    if (cv && vid === cv && !getCookie('_tv_vid')) {
      setCookie('_tv_vid', vid, 34560000);
      setCookie('_tv_sid', sid, 1800);
    }

    if (mintAllowed) {
      setCookie('_tv_vid', vid, 34560000);
      setCookie('_tv_sid', sid, 1800);
    }

    var isNew = sid !== store.sid;
    store.vid = vid;
    store.sid = sid;
    store.la = now;
    return { store: store, vid: vid, sid: sid, isNew: isNew };
  }

  function captureAttribution(store, isNew) {
    var a = (!isNew && store.attr) || null;
    var c = readCarried();
    if (!a && c.a && typeof c.a === 'object' && c.a.lp) a = c.a;
    if (!a) a = { lp: location.href.slice(0, 2000), ref: (document.referrer || '').slice(0, 2000) };
    var params = null;
    try { params = new URLSearchParams(location.search); } catch (e) {}
    if (params) {
      var clickIds = ['fbclid', 'gclid', 'ttclid', 'msclkid'];
      for (var i = 0; i < clickIds.length; i++) {
        var v = params.get(clickIds[i]);
        if (v) a[clickIds[i]] = v.slice(0, 512);
      }
      var adId = params.get('ad_id');
      if (adId && /^\d{1,30}$/.test(adId)) a.ad_id = adId;
      var placement = params.get('placement');
      if (placement) a.placement = placement.slice(0, 64);
      var view = params.get('view');
      if (view && /^(avatar|story)-[a-z0-9-]{1,40}$/.test(view)) a.view = view;
      var utm = a.utm || {};
      var utmKeys = ['source', 'medium', 'campaign', 'content', 'term'];
      var hasUtm = false;
      for (var j = 0; j < utmKeys.length; j++) {
        var uv = params.get('utm_' + utmKeys[j]);
        if (uv) { utm[utmKeys[j]] = uv.slice(0, 256); hasUtm = true; }
      }
      if (hasUtm || a.utm) a.utm = utm;
    }
    var fbp = getCookie('_fbp'); if (fbp) a.fbp = fbp;
    var fbc = getCookie('_fbc'); if (fbc) a.fbc = fbc;
    var ttp = getCookie('_ttp'); if (ttp) a.ttp = ttp;
    store.attr = a;
    return a;
  }

  function urlParam(url, name) {
    try { return new URL(url).searchParams.get(name); } catch (e) { return null; }
  }
  function hostOf(url) {
    try { return new URL(url).hostname.replace(/^www\./, ''); } catch (e) { return ''; }
  }
  var UA = navigator.userAgent || '';
  var IN_APP = /Instagram/.test(UA) ? 'Instagram app' : /FBAN|FBAV|FB_IAB/.test(UA) ? 'Facebook app' : '';
  var META_SOURCES = /^(facebook|instagram|fb|ig|meta)$/i;

  function fbcClickDate(fbc) {
    var ms = Number(String(fbc).split('.')[2]);
    return ms ? new Date(ms).toISOString().slice(0, 10) : '';
  }

  function sourceLabel(a) {
    var utm = a.utm || {};
    var adId = a.ad_id || urlParam(a.lp, 'ad_id');
    var placement = a.placement || urlParam(a.lp, 'placement');
    var paid = /^(paid|cpc|paid_social)$/i.test(utm.medium || '');
    var refHost = hostOf(a.ref);
    var parts;
    if (adId || (paid && META_SOURCES.test(utm.source || ''))) {
      parts = ['Meta ad', utm.content || utm.campaign, placement, adId && 'ad ' + adId];
    } else if (a.gclid) {
      parts = ['Google ad', utm.campaign];
    } else if (a.ttclid) {
      parts = ['TikTok ad', utm.campaign];
    } else if (utm.source) {
      parts = [utm.source, utm.medium, utm.content];
    } else if (a.fbclid) {
      parts = ['Meta link click', 'no ad tag'];
    } else if (refHost && !/trivelle\.store|myshopify\.com|shop\.app/.test(refHost)) {
      parts = ['Referral', refHost];
    } else if (a.fbc) {
      parts = ['Meta link click ' + fbcClickDate(a.fbc), 'no ad tag'];
    } else {
      parts = ['Direct / unknown'];
    }
    if (IN_APP) parts.push('in ' + IN_APP);
    return parts.filter(Boolean).join(' · ').slice(0, 255);
  }

  function cartUpdateUrl() {
    var base =
      (typeof Theme !== 'undefined' && Theme.routes && Theme.routes.cart_update_url) || '/cart/update';
    return base.indexOf('.js') === -1 ? base + '.js' : base;
  }

  function avatarPacked() {
    var av = window.tvAv;
    return av && av.av ? [av.av, av.seg || 'core', av.ad || '', av.angle || ''].join('|') : '';
  }

  function cartMarker() {
    return state.sid + '|' + JSON.stringify(state.attr || {}) + '|' + avatarPacked();
  }

  function writeCartAttributes() {
    if (!state) return Promise.resolve();
    var attrJson = JSON.stringify(state.attr || {});
    var marker = cartMarker();
    var store = readStore();
    if (store.w === marker) return Promise.resolve();
    var attributes = {
      _tv_source: sourceLabel(state.attr || {}),
      _tv_vid: state.vid,
      _tv_sid: state.sid,
      _tv_attr: attrJson,
    };
    var packed = avatarPacked();
    if (packed) attributes._tv_av = packed;
    return fetch(cartUpdateUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes }),
    })
      .then(function (res) {
        if (res.ok) {
          var s = readStore();
          s.w = marker;
          writeStore(s);
        }
      })
      .catch(function () {});
  }

  function catchUpIfCartExists() {
    if (!state) return;
    var store = readStore();
    if (store.w === cartMarker()) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (cart && cart.item_count > 0) writeCartAttributes();
      })
      .catch(function () {});
  }

  function refresh() {
    try {
      var ids = ensureIds();
      var attr = captureAttribution(ids.store, ids.isNew);
      writeStore(ids.store);
      state = { vid: ids.vid, sid: ids.sid, attr: attr };
    } catch (e) {
      state = null;
    }
  }

  var armed = false;
  function armCartBridge() {
    if (armed || !state) return;
    armed = true;
    document.addEventListener('cart:update', function () {
      try { writeCartAttributes(); } catch (e) {}
    });
    window.__tvWriteCartAttributes = writeCartAttributes;
    catchUpIfCartExists();
  }

  var paramBuilderStarted = false;
  function startParamBuilder() {
    var src = SCRIPT_EL && SCRIPT_EL.getAttribute('data-tv-param-builder');
    if (paramBuilderStarted || !src) return;
    paramBuilderStarted = true;
    var s = document.createElement('script');
    s.src = src;
    s.async = true;
    s.onload = function () {
      try {
        window.clientParamBuilder.processAndCollectAllParams(location.href).catch(function () {});
      } catch (e) {}
    };
    document.head.appendChild(s);
  }

  function allowed(api) {
    if (!api) return false;
    try {
      if (typeof api.analyticsProcessingAllowed === 'function' && typeof api.marketingAllowed === 'function') {
        var sale = typeof api.saleOfDataAllowed === 'function' ? api.saleOfDataAllowed() : true;
        return api.analyticsProcessingAllowed() && api.marketingAllowed() && sale;
      }
      var c = (api.currentVisitorConsent && api.currentVisitorConsent()) || {};
      return c.analytics !== 'no' && c.marketing !== 'no' && c.sale_of_data !== 'no';
    } catch (e) {
      return false;
    }
  }

  var SCRIPT_EL = document.currentScript || document.querySelector('script[src*="trivelle-attribution"]');
  var CRO_URL = (SCRIPT_EL && SCRIPT_EL.getAttribute('data-tv-track-endpoint')) || '';
  var CRO_KEY = (SCRIPT_EL && SCRIPT_EL.getAttribute('data-tv-track-key')) || '';
  var CRO_NAME = /^tv_[a-z0-9_]{1,48}$/;
  var CRO_FLUSH_AT = 10;
  var CRO_IDLE_MS = 4000;
  var CRO_MAX_BATCH = 20;
  var CRO_MAX_QUEUE = 60;
  var croQueue = [];
  var croTimer = null;
  var croState = 0;

  function croPost(batch) {
    var body = JSON.stringify({ k: CRO_KEY, events: batch });
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(CRO_URL, new Blob([body], { type: 'application/json' }))) return;
    } catch (e) {}
    try {
      fetch(CRO_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        keepalive: true,
        body: body,
      }).catch(function () {});
    } catch (e) {}
  }

  function croFlush() {
    if (croTimer) { clearTimeout(croTimer); croTimer = null; }
    if (croState !== 1 || !CRO_URL) return;
    while (croQueue.length) croPost(croQueue.splice(0, CRO_MAX_BATCH));
  }

  function croEnqueue(name, data) {
    if (!CRO_URL || croState === -1) return;
    if (typeof name !== 'string' || !CRO_NAME.test(name)) return;
    var ev = {
      name: name,
      vid: (state && state.vid) || null,
      sid: (state && state.sid) || null,
      url: location.pathname,
      occurredAt: new Date().toISOString(),
    };
    var cfbp = getCookie('_fbp'); if (cfbp) ev.fbp = cfbp;
    var cfbc = getCookie('_fbc'); if (cfbc) ev.fbc = cfbc;
    var cttp = getCookie('_ttp'); if (cttp) ev.ttp = cttp;
    if (data && typeof data === 'object') ev.data = data;
    croQueue.push(ev);
    if (croQueue.length > CRO_MAX_QUEUE) croQueue.splice(0, croQueue.length - CRO_MAX_QUEUE);
    if (croState !== 1) return;
    if (croQueue.length >= CRO_FLUSH_AT) { croFlush(); return; }
    if (croTimer) clearTimeout(croTimer);
    croTimer = setTimeout(croFlush, CRO_IDLE_MS);
  }

  function croConsent(api, decided) {
    if (croState === -1) return;
    if (allowed(api)) { croState = 1; croFlush(); return; }
    var required;
    try {
      required = !!(api && typeof api.shouldShowBanner === 'function' && api.shouldShowBanner());
    } catch (e) {
      required = true;
    }
    if (decided || !required) { croState = -1; croQueue.length = 0; }
  }

  var croArmed = false;
  function armCroListeners() {
    if (croArmed || !CRO_URL) return;
    croArmed = true;

    document.addEventListener('trivelle:track', function (e) {
      var d = (e && e.detail) || {};
      croEnqueue(d.name, d.data);
    });

    if (/^\/cart\/?$/.test(location.pathname)) croEnqueue('tv_cart_view', { surface: 'page' });

    var emCache = { v: '', h: null };
    function hashEmailAsync(raw) {
      var v = typeof raw === 'string' ? raw.trim().toLowerCase() : '';
      if (!v || !window.crypto || !crypto.subtle || !window.TextEncoder) return;
      if (emCache.v === v) return;
      emCache.v = v; emCache.h = null;
      try {
        crypto.subtle.digest('SHA-256', new TextEncoder().encode(v)).then(function (buf) {
          if (emCache.v !== v) return;
          var a = new Uint8Array(buf), out = '';
          for (var i = 0; i < a.length; i++) out += (a[i] < 16 ? '0' : '') + a[i].toString(16);
          emCache.h = out;
        }).catch(function () {});
      } catch (e) {}
    }
    function emHash(raw) {
      var v = typeof raw === 'string' ? raw.trim().toLowerCase() : '';
      return v && emCache.v === v ? emCache.h : null;
    }
    window.TrivelleAttribution = window.TrivelleAttribution || {};
    window.TrivelleAttribution.emHash = emHash;
    window.TrivelleAttribution.prepEmail = hashEmailAsync;
    document.addEventListener('input', function (e) {
      var t = e.target;
      if (t && t.name === 'contact[email]') hashEmailAsync(t.value);
    }, true);
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.nodeName !== 'FORM') return;
      var input = form.querySelector('input[name="contact[email]"]');
      if (!input) return;
      if (form.classList.contains('tv-sc-claim')) return;
      var h = emHash(input.value);
      var isContact = !!form.querySelector('[name="contact[body]"]');
      croEnqueue(isContact ? 'tv_contact_submit' : 'tv_newsletter_submit', h ? { em: h } : {});
      croFlush();
    }, true);

    var upsellSeen = false;
    function checkUpsellImpression() {
      var card = document.querySelector(':is(.tv-cart-extras, .tv-du) [data-tv-upsell-add]:not(.tv-together__add):not(.tv-nextroom__add):not(.tv-ritual-row [data-tv-upsell-add])');
      if (card && !upsellSeen) {
        upsellSeen = true;
        croEnqueue('tv_cart_cross_sell_impression', {});
      } else if (!card) {
        upsellSeen = false;
      }
    }
    checkUpsellImpression();

    if ('MutationObserver' in window) {
      var dlg = document.querySelector('cart-drawer-component dialog');
      if (dlg) {
        var wasOpen = dlg.hasAttribute('open');
        new MutationObserver(function () {
          var isOpen = dlg.hasAttribute('open');
          if (isOpen && !wasOpen) {
            croEnqueue('tv_drawer_opened', {});
            croEnqueue('tv_cart_view', { surface: 'drawer' });
            setTimeout(checkUpsellImpression, 300);
          }
          wasOpen = isOpen;
        }).observe(dlg, { attributes: true, attributeFilter: ['open'] });
      }
    }

    document.addEventListener(
      'click',
      function (e) {
        var t = e.target;
        if (!t || typeof t.closest !== 'function') return;
        if (t.closest('#checkout, .cart__checkout-button')) croEnqueue('tv_checkout_clicked', {});
      },
      true,
    );

    var popupShown = false;
    var popupDismissed = false;
    document.addEventListener('trivelle:popup', function (e) {
      var d = e && e.detail;
      if (d && d.source && d.source !== 'popup') return;
      var isOpen = !!(d && d.open);
      if (isOpen && !popupShown) { popupShown = true; croEnqueue('tv_popup_shown', {}); }
      else if (!isOpen && popupShown && !popupDismissed) { popupDismissed = true; croEnqueue('tv_popup_dismissed', {}); }
    });

    document.addEventListener('visibilitychange', function () { if (document.hidden) croFlush(); });
    window.addEventListener('pagehide', function () { croFlush(); });
  }

  var AV_KEY = 'trivelle:av';

  function preferencesAllowed(api) {
    if (!api) return false;
    try {
      var required = typeof api.shouldShowBanner === 'function' && api.shouldShowBanner();
      if (!required) return true;
      return typeof api.preferencesProcessingAllowed === 'function' && api.preferencesProcessingAllowed();
    } catch (e) {
      return false;
    }
  }

  function rememberAvatar(api) {
    var av = window.tvAv;
    if (!av || !preferencesAllowed(api)) return;
    try {
      var saved = JSON.parse(localStorage.getItem(AV_KEY) || 'null');
      if (!av.fresh && saved && saved.av) return;
      localStorage.setItem(AV_KEY, JSON.stringify({ av: av.av, seg: av.seg, ad: av.ad, angle: av.angle, t: Date.now() }));
    } catch (e) {}
  }

  function logAvatarLanding() {
    var av = window.tvAv;
    if (!av || !av.fresh || !state) return;
    var store = readStore();
    var mark = state.sid + '|' + avatarPacked();
    if (store.avl === mark) return;
    store.avl = mark;
    writeStore(store);
    croEnqueue('tv_av_land', { av: av.av, seg: av.seg, ad: av.ad, angle: av.angle, page: location.pathname });
  }

  function tagClarity(triesLeft) {
    var av = window.tvAv;
    if (!av) return;
    if (typeof window.clarity === 'function') {
      try {
        window.clarity('set', 'tv_avatar', av.av);
        window.clarity('set', 'tv_segment', av.seg);
        if (av.ad) window.clarity('set', 'tv_ad', av.ad);
      } catch (e) {}
      return;
    }
    if (triesLeft > 0) setTimeout(function () { tagClarity(triesLeft - 1); }, 2000);
  }

  refresh();
  document.addEventListener('submit', function (e) {
    try {
      var f = e.target;
      if (!f || !f.classList || !f.classList.contains('tv-sc-claim')) return;
      var token = carry();
      if (!token) return;
      var base = (f.getAttribute('action') || '/contact').split('#');
      f.setAttribute('action', base[0] + '#' + (base[1] || 'contact_form') + CARRY_KEY + token);
    } catch (err) {}
  }, true);
  try { window.TrivelleAttribution = { carry: carry }; } catch (e) {}
  armCroListeners();
  logAvatarLanding();
  tagClarity(5);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) refresh();
  });
  window.addEventListener('pageshow', function () { refresh(); });

  function updateMint(api) {
    try {
      var required = api && typeof api.shouldShowBanner === 'function' && api.shouldShowBanner();
      mintAllowed = !required || allowed(api);
    } catch (e) {
      mintAllowed = false;
    }
    if (mintAllowed) refresh();
  }

  if (!window.Shopify || !window.Shopify.loadFeatures) return;
  window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
    if (error) return;
    updateMint(window.Shopify.customerPrivacy);
    rememberAvatar(window.Shopify.customerPrivacy);
    croConsent(window.Shopify.customerPrivacy, false);
    if (allowed(window.Shopify.customerPrivacy)) {
      armCartBridge();
      startParamBuilder();
    }
    document.addEventListener('visitorConsentCollected', function () {
      updateMint(window.Shopify.customerPrivacy);
      rememberAvatar(window.Shopify.customerPrivacy);
      croConsent(window.Shopify.customerPrivacy, true);
      if (allowed(window.Shopify.customerPrivacy)) {
        armCartBridge();
        startParamBuilder();
      }
    });
  });
})();
